const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class ProductUpsellsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    requestAnimationFrame(() => {
      this.initCarousel()
    })
  }

  initCarousel () {
    const visibleSlides = this.els.slide.elements.filter(
      (slide) => slide.getAttribute('aria-hidden') !== 'true',
    )

    const arrowsRequired = visibleSlides.length > 1

    if (this.els.arrows?.element) {
      this.els.arrows.element.setAttribute(
        'aria-hidden',
        String(!arrowsRequired),
      )
      this.els.arrows.element.hidden = !arrowsRequired
    }

    if (visibleSlides.length < 2) return

    if (this.els.next?.element) {
      const clone = this.els.next.element.cloneNode(true)
      this.els.next.element.replaceWith(clone)
    }

    if (this.els.previous?.element) {
      const clone = this.els.previous.element.cloneNode(true)
      this.els.previous.element.replaceWith(clone)
    }

    const slidesEl = this.els.slides.element
    const slidesClone = slidesEl.cloneNode(true)
    slidesEl.replaceWith(slidesClone)

    slidesClone.removeAttribute('data-initialised')
    slidesClone.style.cssText = ''
    slidesClone
      .querySelectorAll('[data-product-upsells-carousel-el="slide"]')
      .forEach((slide) => {
        slide.style.cssText = ''
      })

    this.carousel = new KeenSlider(
      slidesClone,
      {
        selector: () =>
          Array.from(
            slidesClone.querySelectorAll(
              '[data-product-upsells-carousel-el="slide"]',
            ),
          ).filter((slide) => slide.getAttribute('aria-hidden') !== 'true'),
        defaultAnimation: {
          duration: 1500,
        },
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 8,
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }

  refresh () {
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null
    }

    this.initCarousel()
  }
}

if (!customElements.get('product-upsells-carousel')) {
  customElements.define('product-upsells-carousel', ProductUpsellsCarousel)
}
